export const FETCH_STARTED = "FETCH_STARTED";
export const RESET_PAYMENT_DELETE_STATE = "RESET_PAYMENT_DELETE_STATE";
export const RESET_PAYMENT_HISTORY_STATE = "RESET_PAYMENT_HISTORY_STATE";
export const RESET_ERROR_STATUS = "RESET_ERROR_STATUS";
export const GET_FUTURE_SCHEDULED_PAYMENTS_SUCCEEDED = "GET_FUTURE_SCHEDULED_PAYMENTS_SUCCEEDED";
export const GET_FUTURE_SCHEDULED_PAYMENTS_FAILED = "GET_FUTURE_SCHEDULED_PAYMENTS_FAILED";
export const GET_PAYMENTS_HISTORY_SUCCEEDED = "GET_PAYMENTS_HISTORY_SUCCEEDED";
export const GET_PAYMENTS_HISTORY_FAILED = "GET_PAYMENTS_HISTORY_FAILED";
export const CANCEL_FUTURE_SCHEDULED_PAYMENTS_SUCCEEDED = "CANCEL_FUTURE_SCHEDULED_PAYMENTS_SUCCEEDED";
export const CANCEL_FUTURE_SCHEDULED_PAYMENTS_FAILED= "CANCEL_FUTURE_SCHEDULED_PAYMENTS_FAILED";
export const DELETE_PAYMENT_SCHEDULE_SUCCEEDED= "DELETE_PAYMENT_SCHEDULE_SUCCEEDED";
export const DELETE_PAYMENT_SCHEDULE_FAILED= "DELETE_PAYMENT_SCHEDULE_FAILED";
export const RETRY_PAYMENT_SCHEDULE_SUCCEEDED= "RETRY_PAYMENT_SCHEDULE_SUCCEEDED";
export const RETRY_PAYMENT_SCHEDULE_FAILED= "RETRY_PAYMENT_SCHEDULE_FAILED";
export const RESET_RETRY_PAYMENT_SCHEDULE_STATE = "RESET_RETRY_PAYMENT_SCHEDULE_STATE";

